import React from 'react'
import {
  columnCover,
  columnInfo,
  columnName,
  columnExtLevel,
  columnExtTags,
  columnExtLabels,
  columnExtContentLangs,
  columnExtProductIds,
  columnSimpleLimit,
  columnDraftState,
} from 'components/template-data-table-column'
import { openTemplatesByPublisher } from 'commons/worksLinks'
import { DataTableRowActions } from './data-table-row-action'

const columnPublisher = {
  header: 'Publisher',
  accessorKey: 'publisher',
  cell: ({ row }) => {
    const publisherId = row.original.painter
    const name = row.original.publisher

    if (!publisherId) {
      return <span>{name || '-'}</span>
    }

    return (
      <button
        type="button"
        className="font-medium underline underline-offset-4"
        title={publisherId}
        onClick={(e) => {
          e.stopPropagation()
          openTemplatesByPublisher(publisherId)
        }}
      >
        {name || publisherId}
      </button>
    )
  },
}

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnName,
  columnPublisher,
  columnInfo,
  columnDraftState,
  columnSimpleLimit,
  columnExtLevel,
  columnExtTags,
  columnExtLabels,
  columnExtContentLangs,
  columnExtProductIds,
  {
    header: 'Actions',
    cell: ({ row }) => (
      <div onClick={(e) => e.stopPropagation()}>
        <DataTableRowActions row={row} />
      </div>
    ),
  },
]
